// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StaticPageManagement-space1-_SJze {
	margin-bottom: 6px !important;
}

.StaticPageManagement-space2-uVR6e {
	margin-bottom: 12px !important;
}

.StaticPageManagement-space3-ZtgTz {
	margin-bottom: 18px !important;
}

.StaticPageManagement-space4-tIaYI {
	margin-bottom: 24px !important;
}

.StaticPageManagement-space5-n7cCI {
	margin-bottom: 30px !important;
}

.StaticPageManagement-space6-GFOZF {
	margin-bottom: 36px !important;
}

.StaticPageManagement-space7-f0zpO {
	margin-bottom: 42px !important;
}

.StaticPageManagement-space8-JrET7 {
	margin-bottom: 48px !important;
}

.StaticPageManagement-spaceTop1-KD_Bo {
	margin-top: 6px !important;
}

.StaticPageManagement-spaceTop2-VXTM2 {
	margin-top: 12px !important;
}

.StaticPageManagement-spaceTop3-Kpvgg {
	margin-top: 18px !important;
}

.StaticPageManagement-spaceTop4-omRO2 {
	margin-top: 24px !important;
}

.StaticPageManagement-spaceTop5-l3K9Q {
	margin-top: 30px !important;
}

.StaticPageManagement-spaceTop6-ZRSs9 {
	margin-top: 36px !important;
}

.StaticPageManagement-spaceTop7-S2mST {
	margin-top: 42px !important;
}

.StaticPageManagement-spaceTop8-HalAg {
	margin-top: 48px !important;
}

.StaticPageManagement-noMargin-L8vmv {
	margin: 0px !important;
}

.StaticPageManagement-padding1-JWigj {
	padding-bottom: 6px !important;
}

.StaticPageManagement-padding2-Q8pdg {
	padding-bottom: 12px !important;
}

.StaticPageManagement-padding3-g4JIX {
	padding-bottom: 18px !important;
}

.StaticPageManagement-padding4-lTgx7 {
	padding-bottom: 24px !important;
}

.StaticPageManagement-padding5-tMqtS {
	padding-bottom: 30px !important;
}

.StaticPageManagement-padding6-n3ly2 {
	padding-bottom: 36px !important;
}

.StaticPageManagement-padding7-e8xXQ {
	padding-bottom: 42px !important;
}

.StaticPageManagement-paddingTop1-uaKsD {
	padding-top: 6px !important;
}

.StaticPageManagement-paddingTop2-ChyXV {
	padding-top: 12px !important;
}

.StaticPageManagement-paddingTop3-XVySw {
	padding-top: 18px !important;
}

.StaticPageManagement-paddingTop4-VO6N8 {
	padding-top: 24px !important;
}

.StaticPageManagement-paddingTop5-ZGO4n {
	padding-top: 30px !important;
}

.StaticPageManagement-paddingTop6-qm84s {
	padding-top: 36px !important;
}

.StaticPageManagement-paddingTop7-BtG5Q {
	padding-top: 42px !important;
}

.StaticPageManagement-noPadding-CCMOV {
	padding: 0px !important;
}

.StaticPageManagement-spaceMarginBottom0-ruaFa {
	margin-bottom: 0;
}

.StaticPageManagement-textBold-dAVRC {
	font-weight: 500 !important;
}

.StaticPageManagement-textBolder-Ettnp {
	font-weight: 700 !important;
}

.StaticPageManagement-textNormal-IZANS {
	font-weight: normal !important;
}

/*New Design Text Colors */

.StaticPageManagement-textDarkBlue-gV24x {
	color: rgb(20, 39, 94) !important;
}

.StaticPageManagement-textLightBlue-f5iom {
	color: rgb(57, 87, 106) !important;
}

.StaticPageManagement-textLightSandleGreen-acwuv {
	color: rgb(76, 86, 41) !important;
}

.StaticPageManagement-textLightBrown-cMKkz {
	color: rgb(115, 79, 33) !important;
}

.StaticPageManagement-textMediumMaroon-e86Jc {
	color: rgb(87, 37, 51) !important;
}

.StaticPageManagement-textBrown-delQY {
	color: rgb(160, 47, 24) !important;
}

.StaticPageManagement-textMaroon-YnjLp {
	color: rgb(155, 49, 67) !important;
}

.StaticPageManagement-textDarkBrown-Zkeff {
	color: rgb(83, 18, 16) !important;
}

.StaticPageManagement-textMediumBrown-fzUVz {
	color: rgb(142, 28, 10) !important;
}

.StaticPageManagement-textSkyBlue-HwtDa {
	color: rgb(37, 117, 141) !important;
}

.StaticPageManagement-textGray-lj1mf {
	color: rgb(77, 65, 51) !important;
}

.StaticPageManagement-errorMessage-L1INw {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.StaticPageManagement-userText-qHVR0 {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.StaticPageManagement-panelHeader-Nmd__ {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.StaticPageManagement-exportSection-WI4qG {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.StaticPageManagement-exportSectionGridSub-X99fi {
	grid-template-columns: 50% 49% !important;
}

.StaticPageManagement-exportText-_clVc {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.StaticPageManagement-exportLinkImg-vPG7O {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.StaticPageManagement-exportImg-fQ4ep {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.StaticPageManagement-linkBtn-zv2GV {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.StaticPageManagement-table-LVoBh {
	display: table;
}

.StaticPageManagement-tableRow-RF69p {
	display: table-row;
}

.StaticPageManagement-tableCell-V0xYp {
	display: table-cell;
	float: none;
}

.StaticPageManagement-formGroup-R0pr4 {
	margin-bottom: 6px;
}

.StaticPageManagement-marginTop0-uqoY7 {
	margin-top: 0;
}

.StaticPageManagement-marginBottom20-LzklW {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.StaticPageManagement-bannerImageBg-jXVXf {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.StaticPageManagement-bannerDelete-qdUYs {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.StaticPageManagement-exportLink-fnqk6 {
	padding-top: 10px;
	padding-right: 10px;
}

.StaticPageManagement-seachContent-AHa7t {
	padding-left: 0px;
	margin-bottom: 5px;
}

.StaticPageManagement-marginBottom9-Urukm {
	margin-bottom: 9px;
}

.StaticPageManagement-spaceTop52-boDZD {
	margin-top: 52px;
}

.StaticPageManagement-profileViewInner-sqQjk {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.StaticPageManagement-profileViewMain-SMhh4 {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.StaticPageManagement-profileViewlabel-Tk6qv {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.StaticPageManagement-profileViewMainContent-oBqT0 {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.StaticPageManagement-reviewsFormStar-y3DPe {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.StaticPageManagement-reviewsFormStar-y3DPe svg {
	cursor: pointer;
}

.StaticPageManagement-addLanguageText-GxVAh {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.StaticPageManagement-exportSection-WI4qG {
		grid-template-columns: 100%;
	}

	.StaticPageManagement-spaceTop52-boDZD {
		margin-top: 18px;
	}

	.StaticPageManagement-exportText-_clVc {
		float: none;
		margin-top: 12px;
	}

	.StaticPageManagement-exportSectionGridSub-X99fi {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.StaticPageManagement-profileViewlabel-Tk6qv {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.StaticPageManagement-profileViewMainContent-oBqT0 {
		width: 100%;
		text-align: center;
	}

	.StaticPageManagement-panelHeader-Nmd__ {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `StaticPageManagement-space1-_SJze`,
	"space2": `StaticPageManagement-space2-uVR6e`,
	"space3": `StaticPageManagement-space3-ZtgTz`,
	"space4": `StaticPageManagement-space4-tIaYI`,
	"space5": `StaticPageManagement-space5-n7cCI`,
	"space6": `StaticPageManagement-space6-GFOZF`,
	"space7": `StaticPageManagement-space7-f0zpO`,
	"space8": `StaticPageManagement-space8-JrET7`,
	"spaceTop1": `StaticPageManagement-spaceTop1-KD_Bo`,
	"spaceTop2": `StaticPageManagement-spaceTop2-VXTM2`,
	"spaceTop3": `StaticPageManagement-spaceTop3-Kpvgg`,
	"spaceTop4": `StaticPageManagement-spaceTop4-omRO2`,
	"spaceTop5": `StaticPageManagement-spaceTop5-l3K9Q`,
	"spaceTop6": `StaticPageManagement-spaceTop6-ZRSs9`,
	"spaceTop7": `StaticPageManagement-spaceTop7-S2mST`,
	"spaceTop8": `StaticPageManagement-spaceTop8-HalAg`,
	"noMargin": `StaticPageManagement-noMargin-L8vmv`,
	"padding1": `StaticPageManagement-padding1-JWigj`,
	"padding2": `StaticPageManagement-padding2-Q8pdg`,
	"padding3": `StaticPageManagement-padding3-g4JIX`,
	"padding4": `StaticPageManagement-padding4-lTgx7`,
	"padding5": `StaticPageManagement-padding5-tMqtS`,
	"padding6": `StaticPageManagement-padding6-n3ly2`,
	"padding7": `StaticPageManagement-padding7-e8xXQ`,
	"paddingTop1": `StaticPageManagement-paddingTop1-uaKsD`,
	"paddingTop2": `StaticPageManagement-paddingTop2-ChyXV`,
	"paddingTop3": `StaticPageManagement-paddingTop3-XVySw`,
	"paddingTop4": `StaticPageManagement-paddingTop4-VO6N8`,
	"paddingTop5": `StaticPageManagement-paddingTop5-ZGO4n`,
	"paddingTop6": `StaticPageManagement-paddingTop6-qm84s`,
	"paddingTop7": `StaticPageManagement-paddingTop7-BtG5Q`,
	"noPadding": `StaticPageManagement-noPadding-CCMOV`,
	"spaceMarginBottom0": `StaticPageManagement-spaceMarginBottom0-ruaFa`,
	"textBold": `StaticPageManagement-textBold-dAVRC`,
	"textBolder": `StaticPageManagement-textBolder-Ettnp`,
	"textNormal": `StaticPageManagement-textNormal-IZANS`,
	"textDarkBlue": `StaticPageManagement-textDarkBlue-gV24x`,
	"textLightBlue": `StaticPageManagement-textLightBlue-f5iom`,
	"textLightSandleGreen": `StaticPageManagement-textLightSandleGreen-acwuv`,
	"textLightBrown": `StaticPageManagement-textLightBrown-cMKkz`,
	"textMediumMaroon": `StaticPageManagement-textMediumMaroon-e86Jc`,
	"textBrown": `StaticPageManagement-textBrown-delQY`,
	"textMaroon": `StaticPageManagement-textMaroon-YnjLp`,
	"textDarkBrown": `StaticPageManagement-textDarkBrown-Zkeff`,
	"textMediumBrown": `StaticPageManagement-textMediumBrown-fzUVz`,
	"textSkyBlue": `StaticPageManagement-textSkyBlue-HwtDa`,
	"textGray": `StaticPageManagement-textGray-lj1mf`,
	"errorMessage": `StaticPageManagement-errorMessage-L1INw`,
	"userText": `StaticPageManagement-userText-qHVR0`,
	"panelHeader": `StaticPageManagement-panelHeader-Nmd__`,
	"exportSection": `StaticPageManagement-exportSection-WI4qG`,
	"exportSectionGridSub": `StaticPageManagement-exportSectionGridSub-X99fi`,
	"exportText": `StaticPageManagement-exportText-_clVc`,
	"exportLinkImg": `StaticPageManagement-exportLinkImg-vPG7O`,
	"exportImg": `StaticPageManagement-exportImg-fQ4ep`,
	"linkBtn": `StaticPageManagement-linkBtn-zv2GV`,
	"table": `StaticPageManagement-table-LVoBh`,
	"tableRow": `StaticPageManagement-tableRow-RF69p`,
	"tableCell": `StaticPageManagement-tableCell-V0xYp`,
	"formGroup": `StaticPageManagement-formGroup-R0pr4`,
	"marginTop0": `StaticPageManagement-marginTop0-uqoY7`,
	"marginBottom20": `StaticPageManagement-marginBottom20-LzklW`,
	"bannerImageBg": `StaticPageManagement-bannerImageBg-jXVXf`,
	"bannerDelete": `StaticPageManagement-bannerDelete-qdUYs`,
	"exportLink": `StaticPageManagement-exportLink-fnqk6`,
	"seachContent": `StaticPageManagement-seachContent-AHa7t`,
	"marginBottom9": `StaticPageManagement-marginBottom9-Urukm`,
	"spaceTop52": `StaticPageManagement-spaceTop52-boDZD`,
	"profileViewInner": `StaticPageManagement-profileViewInner-sqQjk`,
	"profileViewMain": `StaticPageManagement-profileViewMain-SMhh4`,
	"profileViewlabel": `StaticPageManagement-profileViewlabel-Tk6qv`,
	"profileViewMainContent": `StaticPageManagement-profileViewMainContent-oBqT0`,
	"reviewsFormStar": `StaticPageManagement-reviewsFormStar-y3DPe`,
	"addLanguageText": `StaticPageManagement-addLanguageText-GxVAh`
};
module.exports = ___CSS_LOADER_EXPORT___;
